import {toast} from "sonner";
import Restricted from "@/components/permissions/Restricted.tsx";
import {useEffect, useState} from "react";
import {useParams} from "react-router";
import {EmailValidator, RequiredValidator, useForm} from "@/components/form/Helpers.ts";
import Form from "@/components/form/Form.tsx";
import TextField from "@/components/editor/fields/TextField.tsx";
import {Checkbox} from "@/components/ui/checkbox.tsx";
import {Label} from "@/components/ui/label.tsx";
import Field from "@/components/form/Field.tsx";
import FormActions from "@/components/form/FormActions.tsx";
import {Button} from "@/components/ui/button.tsx";
import {keycloakAdminApi} from "@/main.tsx";

type RoleRepresentation = {
    id: string,
    name: string
}

export default function EditUser() {
    const params = useParams();
    const userId = params.id;
    const [form, setForm] = useForm()
    const [roles, setRoles] = useState([])

    useEffect(() => {
        reload()
    }, [userId]);

    async function reload() {
        keycloakAdminApi.get("/users/" + userId).then(res => {
            console.log(res)
            if (res.status == 200) {
                setForm('fieldValues', {
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    email: res.data.email,
                    phone: res.data.attributes?.phone,
                    title: res.data.attributes?.title,
                    address: res.data.attributes?.address,
                    company: res.data.attributes?.company,
                })
            } else {
                toast.error("Hiba a felhasználó adatainak lekérése során")
            }
        }).catch((error) => {
            console.log(error)
            toast.error("Hiba a felhasználó adatainak lekérése során")
        })
        keycloakAdminApi.get(('/users/' + userId + '/role-mappings/realm/')).then(res => {
            console.log(res)
            if (res.status == 200) {
                setRoles(res.data)
            } else {
                toast.error("Hiba a felhasználó adatainak lekérése során")
            }
        })
    }

    async function submit() {
        keycloakAdminApi.put("/users/" + userId, {
            firstName: form.fieldValues.firstName,
            lastName: form.fieldValues.lastName,
            email: form.fieldValues.email,
            attributes: {
                phone: form.fieldValues.phone,
                title: form.fieldValues.title,
                address: form.fieldValues.address,
                company: form.fieldValues.company,
            }
        }).then( async (res) =>  {
            if (res.status == 204) {
                toast.success("Felhasználó adatai sikeresen mentve")
                const availableRoles = (await keycloakAdminApi.get<Array<RoleRepresentation>>(`/users/${userId}/role-mappings/realm/available`)).data
                availableRoles.push(...(await keycloakAdminApi.get<Array<RoleRepresentation>>(`/users/${userId}/role-mappings/realm`)).data)
                const r = ["vsp-admin", "torzsgarda-user"]
                for (const role of r) {
                    if (roles.filter((ro: { name: string }) => ro.name == role).length > 0) {
                        console.log(role)
                        console.log(form.fieldValues[role])
                        if (!form.fieldValues[role]) {
                            const roleobj = availableRoles.filter((x:any) => x.name == role)[0]
                            await keycloakAdminApi.delete(`/users/${userId}/role-mappings/realm`, {data:[roleobj]} )
                        }
                    } else if(form.fieldValues[role]) {
                        console.log(availableRoles.filter((x:any) => x.name == role)[0])
                        const roleobj = availableRoles.filter((x:any) => x.name == role)[0]
                        await keycloakAdminApi.post(`/users/${userId}/role-mappings/realm`, [roleobj])
                    }
                }
            } else if (res.status == 409) {
                toast.error("A megadott adatokkal már létezik felhasználó")
            } else {
                toast.error("Hiba a felhasználó adatainak mentése során")
            }
        })
    }

    return (
        <>
            <Restricted to={"user.any"}>
                <Form formValue={form} onChange={setForm} onSubmit={submit}>
                    <div className={"p-4 flex gap-4"}>
                        <div className={"w-full"}>
                            <div className={"flex gap-4"}>
                                <TextField name={"firstName"} label={"Vezetéknév"} validate={RequiredValidator}/>
                                <TextField name={"lastName"} label={"Keresztnév"} validate={RequiredValidator}/>
                            </div>
                            <TextField name={"email"} label={"Email cím"} validate={EmailValidator}/>
                            <TextField name={"phone"} label={"Telefonszám"}/>
                            <TextField name={"title"} label={"Titulus"}/>
                            <TextField name={"address"} label={"Cím"}/>
                            <TextField name={"company"} label={"Cégnév"}/>
                        </div>
                        <div className={"w-full flex flex-col gap-2"}>
                            <Field name={'vsp-admin'} defaultValue={roles.filter((role: {
                                name: string
                            }) => role.name == "vsp-admin").length > 0}>
                                {(field) => (
                                    <Label className={"text-sm font-medium items-center flex gap-2"}>
                                        <Checkbox checked={field.value} onCheckedChange={field.onChange}/>
                                        Adminisztrátor
                                    </Label>)
                                }
                            </Field>
                            {!form.fieldValues['vsp-admin'] &&
                                <Field name={'torzsgarda-user'} defaultValue={roles.filter((role: {
                                    name: string
                                }) => role.name == "torzsgarda-user").length > 0}>
                                    {(field) => (
                                        <Label className={"text-sm font-medium items-center flex gap-2"}>
                                            <Checkbox checked={field.value} onCheckedChange={field.onChange}/>
                                            Törzsgárda hozzáférés
                                        </Label>)
                                    }
                                </Field>
                            }
                            <div className={"grow"}></div>
                            <FormActions>
                                {(actions) => (
                                    <Button onClick={actions.submit} className={"mb-4"}
                                            type={"submit"}>
                                        Mentés
                                    </Button>
                                )}
                            </FormActions>
                        </div>
                    </div>
                </Form>
            </Restricted>
        </>
    );
}